import CheckoutPricePage, { CheckoutPricePageProps } from './CheckoutPricePage';

export type { CheckoutPricePageProps };
export default CheckoutPricePage;
